import type { SVGProps } from "react";
import * as React from "react";
const SvgDustLogoLayer2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 96 24"
    {...props}
  >
    <path fill="#418B5C" d="M12 0H0v24h12V0Z" />
    <path fill="#E14322" d="M48 0H24v12h24V0Z" />
    <path
      fill="#3B82F6"
      fillRule="evenodd"
      d="M60 12a6 6 0 0 1 0-12h36v12H60Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDustLogoLayer2;
